import {ListReportModel} from './reportModel'

export const initialState: ListReportModel = [
  {
    tabName: undefined,
    sellingContractId: undefined,
    customerCode: undefined,
    customerVersion: undefined,
    groupDomainCode: undefined,
    dataReport: undefined
  },
]
